export default __webpack_public_path__ + "static/media/TTAConnectBlueLogo.e92f5193.svg";